/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getVitals } from 'app/entities/vitals/vitals.reducer';
import { getEntities as getHealthCamps } from 'app/entities/health-camp/health-camp.reducer';
import { BloodGroup } from 'app/shared/model/enumerations/blood-group.model';
import { createEntity, getEntity, reset, updateEntity } from './blood-donor-fitness.reducer';

export const BloodDonorFitnessUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const vitals = useAppSelector(state => state.vitals.entities);
  const healthCamps = useAppSelector(state => state.healthCamp.entities);
  const bloodDonorFitnessEntity = useAppSelector(state => state.bloodDonorFitness.entity);
  const loading = useAppSelector(state => state.bloodDonorFitness.loading);
  const updating = useAppSelector(state => state.bloodDonorFitness.updating);
  const updateSuccess = useAppSelector(state => state.bloodDonorFitness.updateSuccess);
  const bloodGroupValues = Object.keys(BloodGroup);

  const handleClose = () => {
    navigate(`/blood-donor-fitness${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getClinicalDictionaries({}));
    dispatch(getVitals({}));
    dispatch(getHealthCamps({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...bloodDonorFitnessEntity,
      ...values,
      donorType: clinicalDictionaries.find(it => it.id.toString() === values.donorType?.toString()),
      vitals: vitals.find(it => it.id.toString() === values.vitals?.toString()),
      atCamp: healthCamps.find(it => it.id.toString() === values.atCamp?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          bloodType: 'O_POS',
          ...bloodDonorFitnessEntity,
          donorType: bloodDonorFitnessEntity?.donorType?.id,
          vitals: bloodDonorFitnessEntity?.vitals?.id,
          atCamp: bloodDonorFitnessEntity?.atCamp?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.bloodDonorFitness.home.createOrEditLabel" data-cy="BloodDonorFitnessCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.bloodDonorFitness.home.createOrEditLabel">Create or edit a BloodDonorFitness</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="blood-donor-fitness-id"
                  label={translate('tinyMedicRestApp.bloodDonorFitness.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.bloodType')}
                id="blood-donor-fitness-bloodType"
                name="bloodType"
                data-cy="bloodType"
                type="select"
              >
                {bloodGroupValues.map(bloodGroup => (
                  <option value={bloodGroup} key={bloodGroup}>
                    {translate(`tinyMedicRestApp.BloodGroup.${bloodGroup}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.hbLevel')}
                id="blood-donor-fitness-hbLevel"
                name="hbLevel"
                data-cy="hbLevel"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.counselor')}
                id="blood-donor-fitness-counselor"
                name="counselor"
                data-cy="counselor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.phlebotonist')}
                id="blood-donor-fitness-phlebotonist"
                name="phlebotonist"
                data-cy="phlebotonist"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.active')}
                id="blood-donor-fitness-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.cursor')}
                id="blood-donor-fitness-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.lastUpdated')}
                id="blood-donor-fitness-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.microSec')}
                id="blood-donor-fitness-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.bloodDonorFitness.timestampEntry')}
                id="blood-donor-fitness-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="blood-donor-fitness-donorType"
                name="donorType"
                data-cy="donorType"
                label={translate('tinyMedicRestApp.bloodDonorFitness.donorType')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-donor-fitness-vitals"
                name="vitals"
                data-cy="vitals"
                label={translate('tinyMedicRestApp.bloodDonorFitness.vitals')}
                type="select"
              >
                <option value="" key="0" />
                {vitals
                  ? vitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="blood-donor-fitness-atCamp"
                name="atCamp"
                data-cy="atCamp"
                label={translate('tinyMedicRestApp.bloodDonorFitness.atCamp')}
                type="select"
              >
                <option value="" key="0" />
                {healthCamps
                  ? healthCamps.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/blood-donor-fitness" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default BloodDonorFitnessUpdate;
